export const FETCH_ACTIVE_PAYMENT_METHODS_REQUEST = 'FETCH_ACTIVE_PAYMENT_METHODS_REQUEST';
export const FETCH_ACTIVE_PAYMENT_METHODS_SUCCESS = 'FETCH_ACTIVE_PAYMENT_METHODS_SUCCESS';
export const FETCH_ACTIVE_PAYMENT_METHODS_FAILURE = 'FETCH_ACTIVE_PAYMENT_METHODS_FAILURE';

export const CLEAR_PAYMENT_METHOD_ERROR = 'CLEAR_PAYMENT_METHOD_ERROR';
